import { render, staticRenderFns } from "./SegmentedControl.vue?vue&type=template&id=5ba7f151&scoped=true&"
import script from "./SegmentedControl.vue?vue&type=script&lang=ts&"
export * from "./SegmentedControl.vue?vue&type=script&lang=ts&"
import style0 from "./SegmentedControl.vue?vue&type=style&index=0&id=5ba7f151&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba7f151",
  null
  
)

export default component.exports